import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const Logs = () => {
    const [logs, setLogs] = useState([]);

    useEffect(() => {
        loadLogs();
    }, []);

    const loadLogs = async () => {
        try {
            const response = await api.getLogs();
            setLogs(response.data);
        } catch (error) {
            console.error('Ошибка загрузки логов');
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleString('ru-RU');
    };

    return (
        <div className="logs-container">
            <h3>Лог входов в систему</h3>
            <table className="logs-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Пользователь</th>
                        <th>Время входа</th>
                        <th>Статус</th>
                        <th>IP-адрес</th>
                    </tr>
                </thead>
                <tbody>
                    {logs.map(log => (
                        <tr key={log.id}>
                            <td>{log.id}</td>
                            <td>{log.username || 'Неизвестный'}</td>
                            <td>{formatDate(log.login_time)}</td>
                            <td className={log.success ? 'success' : 'error'}>
                                {log.success ? 'Успешно' : 'Ошибка'}
                            </td>
                            <td>{log.ip_address}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Logs;